"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var Link =
/** @class */
function () {
  function Link(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - linkId
   * @return Promise|Observable|any
   */


  Link.prototype.GetLink = function (linkId) {
    return this.restClient.get('Link/UseCase/GetLink', {
      linkId: linkId
    });
  };
  /**
   * @param string - eventId
   * @param number? - page >= 1
   * @param number? - itemsPerPage 1-500
   * @param string? - sortBy shownText|url|linkType|created
   * @param string? - sortDirection ascending|descending
   * @param string? - query
   * @param boolean? - shouldHideDeleted true|false
   * @return Promise|Observable|any
   */


  Link.prototype.ListLinksForEvent = function (eventId, page, itemsPerPage, sortBy, sortDirection, query, shouldHideDeleted) {
    if (page === void 0) {
      page = null;
    }

    if (itemsPerPage === void 0) {
      itemsPerPage = null;
    }

    if (sortBy === void 0) {
      sortBy = null;
    }

    if (sortDirection === void 0) {
      sortDirection = null;
    }

    if (query === void 0) {
      query = null;
    }

    if (shouldHideDeleted === void 0) {
      shouldHideDeleted = null;
    }

    return this.restClient.get('Link/UseCase/ListLinksForEvent', {
      eventId: eventId,
      page: page,
      itemsPerPage: itemsPerPage,
      sortBy: sortBy,
      sortDirection: sortDirection,
      query: query,
      shouldHideDeleted: shouldHideDeleted
    });
  }; // Commands

  /**
   * @param string - linkId
   * @param string - eventId
   * @return Promise|Observable|any
   */


  Link.prototype.AddLinkToEvent = function (linkId, eventId) {
    return this.restClient.post('Link/UseCase/AddLinkToEvent', {
      linkId: linkId,
      eventId: eventId
    });
  };
  /**
   * @param string - linkId
   * @param string - profileId
   * @return Promise|Observable|any
   */


  Link.prototype.AddLinkToProfile = function (linkId, profileId) {
    return this.restClient.post('Link/UseCase/AddLinkToProfile', {
      linkId: linkId,
      profileId: profileId
    });
  };
  /**
   * @param any[] - linkIds
   * @param string - profileId
   * @return Promise|Observable|any
   */


  Link.prototype.AddLinksToProfile = function (linkIds, profileId) {
    return this.restClient.post('Link/UseCase/AddLinksToProfile', {
      linkIds: linkIds,
      profileId: profileId
    });
  };
  /**
   * @param string - poolId
   * @param string - url
   * @param string? - shownText
   * @param string? - linkType
   * @param string? - linkId
   * @return Promise|Observable|any
   */


  Link.prototype.CreateLink = function (poolId, url, shownText, linkType, linkId) {
    if (shownText === void 0) {
      shownText = null;
    }

    if (linkType === void 0) {
      linkType = null;
    }

    if (linkId === void 0) {
      linkId = null;
    }

    return this.restClient.post('Link/UseCase/CreateLink', {
      poolId: poolId,
      url: url,
      shownText: shownText,
      linkType: linkType,
      linkId: linkId
    });
  };
  /**
   * @param string - linkId
   * @return Promise|Observable|any
   */


  Link.prototype.DeleteLink = function (linkId) {
    return this.restClient.post('Link/UseCase/DeleteLink', {
      linkId: linkId
    });
  };
  /**
   * @param string - linkId
   * @return Promise|Observable|any
   */


  Link.prototype.RemoveLink = function (linkId) {
    return this.restClient.post('Link/UseCase/RemoveLink', {
      linkId: linkId
    });
  };
  /**
   * @param string - linkId
   * @param string - eventId
   * @return Promise|Observable|any
   */


  Link.prototype.RemoveLinkFromEvent = function (linkId, eventId) {
    return this.restClient.post('Link/UseCase/RemoveLinkFromEvent', {
      linkId: linkId,
      eventId: eventId
    });
  };
  /**
   * @param string - linkId
   * @param string - profileId
   * @return Promise|Observable|any
   */


  Link.prototype.RemoveLinkFromProfile = function (linkId, profileId) {
    return this.restClient.post('Link/UseCase/RemoveLinkFromProfile', {
      linkId: linkId,
      profileId: profileId
    });
  };
  /**
   * @param any[] - linkIds
   * @param string - profileId
   * @return Promise|Observable|any
   */


  Link.prototype.RemoveLinksFromProfile = function (linkIds, profileId) {
    return this.restClient.post('Link/UseCase/RemoveLinksFromProfile', {
      linkIds: linkIds,
      profileId: profileId
    });
  };
  /**
   * @param string - linkId
   * @param string - linkType
   * @return Promise|Observable|any
   */


  Link.prototype.SetLinkType = function (linkId, linkType) {
    return this.restClient.post('Link/UseCase/SetLinkType', {
      linkId: linkId,
      linkType: linkType
    });
  };
  /**
   * @param string - linkId
   * @param string - shownText
   * @return Promise|Observable|any
   */


  Link.prototype.SetShownText = function (linkId, shownText) {
    return this.restClient.post('Link/UseCase/SetShownText', {
      linkId: linkId,
      shownText: shownText
    });
  };
  /**
   * @param string - linkId
   * @param string - url
   * @return Promise|Observable|any
   */


  Link.prototype.SetUrl = function (linkId, url) {
    return this.restClient.post('Link/UseCase/SetUrl', {
      linkId: linkId,
      url: url
    });
  };
  /**
   * @param string - linkId
   * @param string - poolId
   * @param string? - url
   * @param string? - shownText
   * @param string? - linkType
   * @return Promise|Observable|any
   */


  Link.prototype.UpdateLink = function (linkId, poolId, url, shownText, linkType) {
    if (url === void 0) {
      url = null;
    }

    if (shownText === void 0) {
      shownText = null;
    }

    if (linkType === void 0) {
      linkType = null;
    }

    return this.restClient.post('Link/UseCase/UpdateLink', {
      linkId: linkId,
      poolId: poolId,
      url: url,
      shownText: shownText,
      linkType: linkType
    });
  };

  return Link;
}();

exports.Link = Link;